import { useState } from 'react';
import { DetailsSearchResultPageItem } from '../../types';
import { TableItem } from '@portal_components/components/TableItem';
import { TextInput } from '@portal_components/components/TextInput';
import { ExpandedSearchResult } from './ExpandedSearchResult';
import { useStandingData } from '../../hooks/useStandingData';
import { DateTime } from 'luxon';

interface DetailsSearchResultListProps {
  pageData: DetailsSearchResultPageItem[]; //Record<number, DetailsSearchResultPageItem[]>;
  numberOfResults: number;
  contractId: string;
  customerGroupId: string;
}

export const DetailsSearchResultList = ({ pageData, numberOfResults, contractId, customerGroupId }: DetailsSearchResultListProps) => {
  const {
    standingData: { standingDataSiteStatusList }
  } = useStandingData();
  const [expandedMprnIndex, setExpandedMprnIndex] = useState<number | null>(null);
  const handleExpandClicked = (index: number) => () => {
    if (expandedMprnIndex === index) {
      setExpandedMprnIndex(null);
    } else {
      setExpandedMprnIndex(index);
    }
  };

  const renderDetails = (searchResult: DetailsSearchResultPageItem, index: number) => (
    <div key={searchResult.mprn} className="mb-2">
      <div className="mb-1 py-1 rounded-sm bg-elevation-1 h-16 border-solid border-l-[5px] border-solid-bold-green">
        <TableItem readonly onExpandClicked={handleExpandClicked(index)} expanded={expandedMprnIndex === index}>
          <TextInput title="MPRN" initialValue={searchResult.mprn} readonly hideErrorControl />
          <TextInput title="Site Status" initialValue={standingDataSiteStatusList.find(e => e.value === searchResult.contractSiteStatusId)?.title ?? ''} readonly hideErrorControl />
          <TextInput title="Effective Date" initialValue={searchResult.effectiveDate ? DateTime.fromISO(searchResult.effectiveDate).toFormat('dd/MM/yyyy') : ''} readonly hideErrorControl />
          <TextInput title="Site Reference Name" initialValue={searchResult.siteReferenceName ?? ''} readonly hideErrorControl />
          <TextInput title="Batch Name" initialValue={searchResult.batchName ?? ''} readonly hideErrorControl />
          <TextInput title="Postcode" initialValue={searchResult.postcode ?? ''} readonly hideErrorControl />
        </TableItem>
      </div>
      {expandedMprnIndex === index && (
        <div className="pl-7 pb-4 pt-2">
          <ExpandedSearchResult contractId={contractId} customerGroupId={customerGroupId} mprn={searchResult.mprn} />
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div className="flex flex-row justify-start pb-2">Number of Results: {numberOfResults}</div>
      {pageData.map(renderDetails)}
    </div>
  );
};
